const DEPARTMENT = {
  ADD_NEW_TEAM_BTN: 'ایجاد تیم جدید',
  HEADER_TITLE: 'ایجاد تیم',
  EMPTY_TEAMS_LIST: 'تیمی ایجاد نشده است',
  TEAM_SELECT_DESCRIPTION:
    'برای انجام تنظیمات روی تیم ها ابتدا وبسایت مورد نظر خود را انتخاب کنید.',
  DELETE_DEFAULT_TEAM_ERROR: 'امکان حذف تیم پیش‌ فرض وجود ندارد',
  DEFAULT_TEAM_TOOLTIP:
    'با انتخاب شروع گفتگو پیامهای کاربر به این تیم ارسال خواهد شد',
  DEFAULT_TEAM_BADGE: 'تیم پیشفرض',
  OPERATOR_COUNT_TEXT: 'اپراتور',
  EDIT_MODAL_TITLE: 'ویرایش تیم',
  DELETE_MODAL_TITLE: 'حذف تیم',
  EMPTY_TEAM_ERROR: 'نام تیم نمی‌تواند خالی باشد',
  EMPTY_OPERATORS_LIST: 'لیست اپراتورها نمیتواند خالی باشد',
  SUBMIT_TEXT: 'تایید',
  NO_OPERATOR_YET: 'اپراتوری افزوده نشده است',
  ENTER_TEAM_NAME: 'نام تیم را وارد کنید.',
  UPLOAD_LOGO: 'بارگذاری لوگو',
  OPERATORS_HEADER_TITLE: 'اپراتورها',
  REMOVE_IMAGE_BTN_TEXT: 'حذف تصویر',
  SEARCH_OPERATOR_PLACEHOLDER: 'اپراتورهای خود را به این تیم اضافه کنید',
  SEARCH_RESULT_NO_OPERATOR: 'اپراتوری پیدا نشد',
  SEARCH_OPERATOR_RESULT_ADD_BTN: 'افزودن',
  SEARCH_OPERATOR_RESULT_REMOVE_BTN: 'حذف',
  REMOVE_OPERATOR_BTN_LABEL: 'حذف',
  ADD_TEAM_MODAL_HEADER_TITLE: 'ایجاد تیم',
  REMOVE_TEAM_MODAL_TITLE: 'آیا از حذف این تیم مطمئن هستید؟',
  ADD_TEAM_DESC:
    'با استفاده از قابلیت "ایجاد تیم"، می‌توانید تیم‌هایی با تخصص‌های متفاوت بسازید و برای هرکدام اپراتور مخصوص اختصاص دهید. به عنوان مثال، یک تیم برای مشکلات فنی یا یک تیم مالی تشکیل دهید."',
  ERROR_MESSAGE: 'پر کردن تمامی فیلدها الزامی می‌باشد!',
  NAME_ERROR_MESSAGE: 'وارد کردن نام تیم ضروری می‌باشد!',
  MEMBER_ERROR_MESSAGE: 'انتخاب حداقل یک عضو برای تیم ضروری می‌باشد!',
};

export default DEPARTMENT;
